<template>
    <div>



        <!-- <h5 :class="{hideExtraFields:hideExtraFields}">
            {{ $globals.titleIdToName(contact.title) }}
        </h5> -->

        <div class="row">

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        שם פרטי
                    </label>
                    <input class="form-control"
                           v-model="contact.firstName">

                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.firstName }}
                    </span>



                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        שם משפחה
                    </label>
                    <input class="form-control"
                           v-model="contact.lastName">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.lastName }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        טלפון
                    </label>
                    <input class="form-control"
                           type="tel"
                           style="direction: ltr;text-align: right;"
                           @input="contact.phone = contact.phone.replace(/(?!^\+)[^0-9]/g, '')"
                           @blur="$emit('phoneEntered', contact)"
                           v-model="contact.phone">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.phone }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 v-if="!hideNonEssentialFields">
                <div class="mb-3">
                    <label class="form-label">
                        תפקיד
                        <span style="color:#ab8ce4;cursor:pointer;float:left"
                              @click="$refs.QuickEditContactTitles.show()">
                            ניהול מהיר
                        </span>
                    </label>

                    <QuickEdit controller="customer-contact-titles"
                               ref="QuickEditContactTitles"
                               :title="$t('QuickEditContactTitles')"
                               listName="contactTitles"></QuickEdit>




                    <Multiselect label="name"
                                 track-by="id"
                                 v-model="contact.title"
                                 deselect-label=""
                                 placeholder=""
                                 selectLabel=""
                                 selectedLabel=""
                                 tagPlaceholder="הקישו אנטר ליצירת  תפקיד חדש"
                                 :allow-empty="false"
                                 :showNoOptions="false"
                                 :options="this.$store.state.contactTitles.filter(x => !x.hidden)"
                                 :taggable="true"
                                 @tag="$handlers.listsHandler.createListItem($event, 'contactTitles', 'customer-contact-titles', contact, 'title')">
                        <template slot="noResult">לא נמצאו תוצאות</template>
                    </Multiselect>

                </div>
            </div>


        </div>



        <div class="row"
             :class="{ hideExtraFields: actualHideExtraFields && !(contact.errors && (contact.errors.forceOpenExtraFields)) }">

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        מייל
                    </label>
                    <input class="form-control"
                           type="mail"
                           v-model="contact.email">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.email }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        תעודת זהות / מספר ח.פ.
                    </label>
                    <input class="form-control"
                           type="number"
                           v-model="contact.teudatZehut">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.teudatZehut }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        רחוב
                    </label>
                    <input class="form-control"
                           v-model="contact.address_street">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.address_street }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        מספר בית
                    </label>
                    <input class="form-control"
                           v-model="contact.address_number">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.address_number }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        עיר
                    </label>
                    <input class="form-control"
                           v-model="contact.address_city">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.address_city }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 :class="{ hideNonEssentialFields }">
                <div class="mb-3">
                    <label class="form-label">
                        מיקוד
                    </label>
                    <input class="form-control"
                           type="number"
                           v-model="contact.address_mikud">
                    <span class="formErrorText"
                          v-if="contact.errors">
                        {{ contact.errors.address_mikud }}
                    </span>
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 v-if="!hideNonEssentialFields">
                <div class="mb-3">
                    <label class="form-label">
                        הערה אישית
                    </label>
                    <input class="form-control"
                           v-model="contact.comment">
                </div>
            </div>

            <div class="col-md-3 col-sm-6"
                 v-for="cf in contactCustomFields"
                 :key="'cf' + cf.id"
                 :class="{ hideNonEssentialFields }">
                <CustomFieldInput :field="cf" :owner="contact"></CustomFieldInput>
            </div>

        </div>





        <div class="pull-right toggleExtraFieldsButton"
             style="cursor:pointer;color:#ab8ce4;"
             v-show="!(contact.errors && contact.errors.forceOpenExtraFields)"
             @click="toggleHideExtraFields()">

            {{ actualHideExtraFields ? 'הצג' : 'הסתר' }}
            שדות נוספים
        </div>


        <div class="pull-right toggleExtraFieldsButton"
             style="color:#aaaaaa;"
             v-show="!hideChangePicButton">
            &nbsp;
            |
            &nbsp;
        </div>



        <div class="pull-right toggleExtraFieldsButton"
             style="cursor:pointer;color:#ab8ce4;"
             @click="refreshContactPic"
             v-show="!hideChangePicButton">

            {{ picButtonText }}
        </div>

        <div class="pull-right toggleExtraFieldsButton"
             style="color:#aaaaaa;"
             v-show="!hideChangePicButton && contact.id">
            &nbsp;
            |
            &nbsp;
        </div>

        <div class="pull-right toggleExtraFieldsButton"
             style="cursor:pointer;color:#ab8ce4;"
             @click="generateAndCopyContactLink"
             v-show="contact.id">
            {{ linkButtonText }}
        </div>

        <div style="clear:both"></div>

        <!-- Contact Link Modal -->
        <div v-if="showLinkModal" class="modal-overlay" @click="showLinkModal = false">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h5>קישור לטופס איש קשר</h5>
                    <button class="close-btn" @click="showLinkModal = false">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="link-display">{{ generatedLink }}</div>
                    <button class="copy-btn" @click="copyLinkFromModal">{{ copyButtonText }}</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import QuickEdit from '../QuickEdit/QuickEdit.vue';
import Multiselect from 'vue-multiselect';
import ListsHandler from '../../modules/ListsHandler';
import CustomFieldInput from '../CustomFields/CustomFieldInput.vue';

export default {
    name: "CustomerContactFields",
    props: {
        hideChangePicButton: Boolean,
        hideNonEssentialFields: { default: false },
        hideExtraFields: Boolean,
        eventId: { default: null },
        contact: {
            type: Object
        }
    },
    methods: {

        //"עדכן תמונה" used to pop the global green "הפעולה התבצעה בהצלחה" even when the pull came
        //back with nothing — a success message for a picture that never arrived. Pull quietly and
        //say what actually happened (a hidden picture is a privacy setting on the contact's side,
        //not something pressing again will fix).
        async refreshContactPic() {

            if (this.picButtonText != 'עדכן תמונה')
                return;

            this.picButtonText = 'מושך תמונה...';

            try {

                //not `let {pic, reason} = await ...` — destructuring an await doesn't compile here
                let pull = await this.$handlers.whatsappHandler.getProfilePic(this.contact, true);

                this.$swal({
                    type: pull.pic ? 'success' : 'info',
                    title: pull.pic ? 'תמונת הפרופיל עודכנה' : this.$handlers.whatsappHandler.profilePicMessage(pull.reason),
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });

            } catch (e) {
                //apiRequest already popped the global error alert
                console.error(e);
            }

            this.picButtonText = 'עדכן תמונה';

        },

        toggleHideExtraFields() {
            this.actualHideExtraFields = !this.actualHideExtraFields;
        },
        async generateAndCopyContactLink() {
            if (!this.eventId) {
                alert('לא ניתן ליצור קישור ללא אירוע. אנא בחר אירוע תחילה.');
                return;
            }
            
            this.linkButtonText = 'מייצר קישור...';
            
            try {
                const result = await this.$handlers.eventHandler.generateContactFormLink(this.contact.id, this.eventId);
                this.generatedLink = result.url;
                this.showLinkModal = true;
                this.linkButtonText = 'העתק קישור לטופס';
            } catch (err) {
                console.error('Failed to generate link:', err);
                alert(err.message || 'שגיאה ביצירת הקישור');
                this.linkButtonText = 'העתק קישור לטופס';
            }
        },
        async copyLinkFromModal() {
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(this.generatedLink);
                } else {
                    // Fallback for iOS and older browsers
                    const textArea = document.createElement('textarea');
                    textArea.value = this.generatedLink;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                }
                
                this.copyButtonText = 'הועתק!';
                setTimeout(() => {
                    this.copyButtonText = 'העתק קישור';
                    this.showLinkModal = false;
                }, 1500);
            } catch (err) {
                console.error('Failed to copy:', err);
                alert(err.message || 'שגיאה בהעתקת הקישור');
            }
        }
    },
    data() {
        return {
            actualHideExtraFields: this.hideExtraFields, //init from prop
            linkButtonText: 'העתק קישור לטופס',
            picButtonText: 'עדכן תמונה',
            showLinkModal: false,
            generatedLink: '',
            copyButtonText: 'העתק קישור'
        }
    },
    computed: {
        contactCustomFields() {
            return (this.$store.state.customFieldDefinitions || []).filter(function(d) {
                return d.appliesTo === 'customer_contact' && !d.isHidden;
            });
        }
    },
    components: { Multiselect, QuickEdit, CustomFieldInput }
}

</script>

<style scoped>
.hideExtraFields {
    display: none;
}


.hideToggleFields .toggleExtraFieldsButton {
    display: none !important
}


.hideNonEssentialFields {
    width: 33.3333% !important
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-content {
    background: white;
    padding: 0;
    border-radius: 8px;
    /* max-width: 500px; */
    width: 90%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid #e0e0e0;
}

.modal-header h5 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.close-btn {
    background: none;
    border: none;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    padding: 0;
}

.close-btn:hover {
    color: #333;
}

.modal-body {
    padding: 20px;
}

.link-display {
    background: #f5f5f5;
    padding: 15px;
    border-radius: 4px;
    word-break: break-all;
    margin-bottom: 15px;
    font-family: monospace;
    font-size: 14px;
    direction: ltr;
    text-align: left;
}

.copy-btn {
    width: 100%;
    padding: 12px;
    background: #ab8ce4;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
}

.copy-btn:hover {
    background: #9a7ad1;
}

.copy-btn:active {
    background: #8969be;
}
</style>